var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHybridIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hybrid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hybrid",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5367425,7.77944347 C15.5367425,12.0639569 12.0644884,15.5370968 7.77908915,15.5370968 C3.49457568,15.5370968 0.0223216332,12.0639569 0.0223216332,7.77944347 C0.0223216332,3.49492999 3.49457568,0.0217901657 7.77908915,0.0217901657 C12.0644884,0.0217901657 15.5367425,3.49492999 15.5367425,7.77944347 L15.5367425,7.77944347 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8111593,7.77944347 C23.8111593,12.0639569 20.3389052,15.5370968 16.053506,15.5370968 C11.7689925,15.5370968 8.29673846,12.0639569 8.29673846,7.77944347 C8.29673846,3.49492999 11.7689925,0.0217901657 16.053506,0.0217901657 C20.3389052,0.0217901657 23.8111593,3.49492999 23.8111593,7.77944347 L23.8111593,7.77944347 Z",
    id: "Stroke-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHybridIcon);
export default __webpack_public_path__ + "static/media/hybridIcon.8e136516f076cf2918d91f591a34b9c2.svg";
export { ForwardRef as ReactComponent };